import { Controller } from 'stimulus'
import GoogleCart from 'mixins/google_chart'

export default class extends GoogleCart(Controller) {

  connect() {
    this.googleConnect()
  }

  disconnect() {
    if (this.chart) this.chart.clearChart()
  }

  googleConnected() {
    google.charts.load("current", { packages: ["corechart"] })
    google.charts.setOnLoadCallback(this.drawChart)
  }

  drawChart = () => {
    this.chart = new google.visualization.PieChart(this.element)
    this.chart.draw(this.data, this.options)
  }


  get data() {
    return google.visualization.arrayToDataTable(JSON.parse(this.element.dataset.data))
  }

  get options() {
    if (this.element.dataset.slices) { this.slices = JSON.parse(this.element.dataset.slices) }
    return {
      chartArea: { left: '5%', top: '5%', width: '90%', height: '90%' },
      legend: { position: 'right', alignment: 'center', textStyle: { fontSize: this.element.dataset.legendfontsize || 13 } },
      pieHole: (this.element.dataset.piehole || 0.7),
      pieSliceText: (this.element.dataset.pieSliceText || 'value'),
      pieSliceTextStyle: { fontSize: this.element.dataset.piefontsize || 12 },
      slices: (this.slices || {
        0: { color: '#EB326E' },
        1: { color: '#EA64CA' },
        2: { color: '#06B59A' },
        3: { color: '#42C7E8' },
        4: { color: '#1A759F' },
      })
    }

  }

}
